import axios from "axios";
import { API } from "@/lib/api";

const client = (token) =>
  axios.create({ baseURL: `${API}/admin/meteocat`, timeout: 20000, headers: { "X-Panel-Token": token } });

export const fetchPanelStatus = async (token) => (await client(token).get("/status")).data;
export const triggerPanelSync = async (token) => (await client(token).post("/sync")).data;
export const setApiPaused = async (token, api, paused) =>
  (await client(token).post("/pause", { api, paused })).data;
